"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRouterDom = require("react-router-dom");
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var R = _interopRequireWildcard(require("ramda"));
var _MenuList2 = _interopRequireDefault(require("./MenuList.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _Dropdown = _interopRequireDefault(require("./Dropdown"));
var _excluded = ["id", "children", "menuItems", "position", "expanded", "itemId", "ignoreSingleItemLogic", "itemsProps", "isActionDisabled", "disabled", "ariaLabel", "item", "optionsTracking"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ICON_SIZE = 28;
var getListItemLabel = function getListItemLabel(item) {
  var _ref = item || {},
    name = _ref.name,
    icon = _ref.icon,
    showIconAsLabel = _ref.showIconAsLabel;
  if (!showIconAsLabel) return name;
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: icon,
    size: ICON_SIZE
  });
};
var getListItemClass = function getListItemClass(showIconAsLabel, isActionDisabled) {
  return (0, _classnames["default"])({
    'single-list-item': true,
    disabled: isActionDisabled,
    'icon-label': showIconAsLabel
  });
};
var MenuList = /*#__PURE__*/function (_React$PureComponent) {
  function MenuList(props) {
    var _this;
    _classCallCheck(this, MenuList);
    _this = _callSuper(this, MenuList, [props]);
    _defineProperty(_this, "handleClickOutside", function () {
      _this.setState({
        isExpanded: false
      });
    });
    _defineProperty(_this, "toggleMenuVisibility", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
      if (typeof _this.props.onToggle === 'function') _this.props.onToggle(!_this.state.isExpanded);
    });
    _defineProperty(_this, "handleSingleMenuItem", function (menuItems, itemId, isActionDisabled, itemProps, item) {
      var firstMenuItem = R.prop(0, menuItems);
      var routerLinkBase = R.prop('routerLinkBase', firstMenuItem);
      var showIconAsLabel = R.prop('showIconAsLabel', firstMenuItem);
      var link = R.prop('link', firstMenuItem);
      var _onClick = R.prop('onClick', firstMenuItem);
      var contextMenuProps = R.prop(R.prop('key', firstMenuItem), itemProps) || {};
      if (routerLinkBase && itemId) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, _extends({}, contextMenuProps, {
          className: getListItemClass(showIconAsLabel, isActionDisabled),
          to: "".concat(routerLinkBase, "/").concat(itemId)
        }), getListItemLabel(firstMenuItem));
      }
      return /*#__PURE__*/_react["default"].createElement("a", _extends({}, contextMenuProps, {
        className: getListItemClass(showIconAsLabel, isActionDisabled),
        href: link,
        onClick: function onClick() {
          return _onClick(itemId, item);
        }
      }), getListItemLabel(firstMenuItem));
    });
    _this.state = {
      isExpanded: props.expanded || false
    };
    return _this;
  }
  _inherits(MenuList, _React$PureComponent);
  return _createClass(MenuList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        children = _this$props.children,
        menuItems = _this$props.menuItems,
        position = _this$props.position,
        expanded = _this$props.expanded,
        itemId = _this$props.itemId,
        ignoreSingleItemLogic = _this$props.ignoreSingleItemLogic,
        itemsProps = _this$props.itemsProps,
        isActionDisabled = _this$props.isActionDisabled,
        disabled = _this$props.disabled,
        ariaLabel = _this$props.ariaLabel,
        item = _this$props.item,
        optionsTracking = _this$props.optionsTracking,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var isExpanded = this.state.isExpanded;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "menulist-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_MenuList2["default"], _extends({
        id: id,
        isExpanded: isExpanded,
        position: position
      }, otherProps), R.length(menuItems) === 1 && !ignoreSingleItemLogic ? this.handleSingleMenuItem(menuItems, itemId, isActionDisabled, itemsProps, item) : !disabled && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "content-toggler",
        onClick: this.toggleMenuVisibility,
        onKeyDown: this.toggleMenuVisibility,
        role: "button",
        "aria-label": ariaLabel || 'Expand menu',
        tabIndex: "0"
      }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "close-button",
        icon: "ion-close-circled",
        size: 24,
        onClick: this.toggleMenuVisibility,
        "aria-label": "Close menu"
      }) : children), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
        className: "list-container"
      }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
        closeMenu: this.handleClickOutside,
        optionsTracking: optionsTracking,
        items: menuItems,
        itemId: itemId,
        itemsProps: itemsProps
      })))));
    }
  }]);
}(_react["default"].PureComponent);
MenuList.propTypes = {
  /** Html id */
  id: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  expanded: _propTypes["default"].bool,
  ignoreSingleItemLogic: _propTypes["default"].bool,
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  onToggle: _propTypes["default"].func,
  position: _propTypes["default"].oneOf(['top-right', 'top-left', 'bottom-left', 'bottom-right']),
  itemId: _propTypes["default"].string,
  itemsProps: _propTypes["default"].shape({}),
  disabled: _propTypes["default"].bool,
  isActionDisabled: _propTypes["default"].bool,
  ariaLabel: _propTypes["default"].string,
  item: _propTypes["default"].shape({}),
  optionsTracking: _propTypes["default"].func
};
MenuList.defaultProps = {
  disabled: false,
  id: '',
  expanded: undefined,
  ignoreSingleItemLogic: false,
  onToggle: undefined,
  position: 'top-right',
  itemId: '',
  item: {},
  itemsProps: undefined,
  isActionDisabled: false,
  ariaLabel: '',
  optionsTracking: function optionsTracking() {}
};
var _default = exports["default"] = (0, _reactClickOutside["default"])(MenuList);